



































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import LeftNavigationComponent from "./LeftNavigation.vue";
import TopNavigationComponent from "./TopNavigation.vue";
import NavigationButtons from "./NavigationButtons.vue";
import DocumentChecklistComponent from "./DocumentChecklist.vue"
import { ApplicantDueDeligence, Workspace } from "@/entities";
import { http as _http } from '@/shared/https';
import "vuetify/dist/vuetify.min.css";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import { AppConstants as _app } from '@/shared/app.constants';
import { Locales } from "@/i18n/locales";

const namespace: string = "conceptNote";

@Component({
  components: {
    TopNavigationComponent,
    VJsonschemaForm,
    LeftNavigationComponent,
    DocumentChecklistComponent,
    NavigationButtons
  }
})
export default class DueDeligenceComponent extends Vue {
  @Action("updateSubMenu", { namespace }) updateKey: any;
  @Action("uploadDocument", { namespace }) uploadDocument: any;
  @Action("saveDueDeligance", { namespace }) saveDueDeligance: any;
  @Getter("appDueDiligence", { namespace }) dueDiligence: ApplicantDueDeligence;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("currency", { namespace }) currency: string;
  @Getter("ddKey", { namespace }) subKey: any;
  @State(namespace) app!: Workspace;
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Prop() isDirty!: boolean;

  /** declare variables */
  formValid: boolean = false;
  showSideBar = true;
  renderComponent: boolean = true;
  data: any = {};
  schemaformKey: number = 0;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  /** set the schema form options */
  get options() { 
    return {
      disableAll: (this.readOnly && this.readOnly === true) ? true : false,
      "uploadAction": this.uploadDocument,
      "removeAction": this.$services.document.removeDocument,
      "downloadAction": this.$services.document.download,
      "locale": this.defaultLocale,
      "ApplicationId": this.app.selectedApplication,
      "currency": this.currency,
      "httpLib": _http,
      "baseURI": process.env.VUE_APP_API_Base_URL,
      "fileSizeLimit": this.appSettings.MaxFileSizeLimit
    };
  }

  mounted() {
    var selectedSubMenu = '';

    // get the default tab
    if(this.subProps.length > 0)       
      var selectedSubMenu = this.subProps[0];

    // update the default tab, if hash value exists
    if(this.$route.params.section === 'applicantDueDeligence' && this.$route.hash) {
      selectedSubMenu = this.$route.hash.substr(1);
    }

    // update the state
    if(selectedSubMenu)
      this.$emit('submenuChanged', { key: 'applicantDueDeligence', subMenu: selectedSubMenu });
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  /**  update the sub menu on left panel selection */
  subMenuChanged(selectedMenu, key) {
    this.$emit('submenuChanged', { key: 'applicantDueDeligence', subMenu: key });
  }

  /** Add new file to the physical location*/
  onAddNewFile(file: any, wrapper: any, key: string ) {
  }
  /** Remove the file from the physical location */
  onRemoveFile(file: any) {

  }
  /** error event */
  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
  }

  /** get summary of the application due diligence */
  summary() {
    this.$services.summary.getDueDeligenceSummary(
      this.dueDiligence.templates,
      this.datum
    );
  }

  /** input event */
  showInput(e) {
    this.$emit("input", true);
    // console.log('"input" event', e)
  }

  /** get all subtabs */
  get subProps(): Array<string> {
    if (this.dueDiligence.templates && this.dueDiligence.templates.properties) {
      return Object.keys(this.dueDiligence.templates.properties);
    } else {
      return [];
    }
  }

  /** get child schema properties to populate the left panel*/
  get subSchema(): any {
    if (this.dueDiligence.templates && this.dueDiligence.templates.properties && this.subKey) {
      var schema = this.dueDiligence.templates.properties[
        this.subKey
      ];
      schema['x-virtual'] = false;
      return schema;
    } else {
      return {};
    }
  }

  /** application data */
  get datum(): any {
    return this.appData;
  }

  /** watch state and update the variable */
  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
    // setTimeout(() => {
    //   (this.$refs.form as Vue & { validate: () => boolean }).validate();
    // }, 1000);
  }

  @Watch("subKey")
  onSubKeyChanged(value: any) {
    this.schemaformKey += 1;
    // reset scroll bar to top
    if(this.$refs.ddWrapper) {
      this.$refs.ddWrapper["scrollTop"] = 0;
    }
  }
}
